import useResource from "../../../hooks/UseResource";
import * as PatientService from "../../../services/PatientService";

export default function usePatient(id) {
    return useResource(id, PatientService.findPatientById);
}
